'use client';

import type { ComponentProps } from 'react';

import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useCheckPartnerWebview } from '@/hooks/useCheckPartnerWebview';

import { CustomLink } from './CustomLink';

type PartnerHomeLinkProps = Omit<ComponentProps<typeof CustomLink>, 'href'>;

//* 카뱅·토스 웹뷰의 에러·404 화면 CTA는 파트너 셸이 있는 기부홈으로 보낸다 — www로 보내면 셸 없는 막다른 길이 된다
export const PartnerHomeLink = (props: PartnerHomeLinkProps) => {
  const isPartnerWebview = useCheckPartnerWebview();

  return (
    <CustomLink
      href={
        isPartnerWebview ? DONATION_ROUTES.HOME.pathname : ROUTES.HOME.pathname
      }
      {...props}
    />
  );
};
